export default __webpack_public_path__ + "static/media/vive argentina.bc4ebca2.png";